export default "__VITE_ASSET__B1vCz5p9__"